import { useOptionButtonStyles } from './OptionButton.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const OptionButton = ({
  name,
  optionValue,
  label,
  isSelected,
  isDisabled = false,
  onChange
}) => {
  const {
    buttonStyle
  } = useOptionButtonStyles({
    isDisabled,
    isSelected
  });
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    "aria-pressed": isSelected,
    disabled: isDisabled,
    onClick: () => onChange(name, optionValue),
    style: buttonStyle,
    children: label
  });
};
export default OptionButton;